module.exports = __webpack_public_path__ + "static/media/lb_02 (1).c292cf92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb_02 (1).jpg
// module id = 2005
// module chunks = 2